<div class="_navigation-desktop-component">
    <div class="_container _logo-container" [ngClass]="{'_small-menu': !menuIsOpen}">
        <img *ngIf="menuIsOpen" class="_logo" src="{{userDetails?.logo || './assets/imgs/digibank.png'}}" />
        <img *ngIf="!menuIsOpen" class="_logo" src="{{userDetails?.favicon || './assets/imgs/digibank_small.svg'}}" />
    </div> 

    <div class="_divider"></div>

    <div class="_container _navigation-button-container">
        <ng-container [ngTemplateOutlet]="navigationItems" [ngTemplateOutletContext]="{isHighlighted: true}"></ng-container>
        <ng-container [ngTemplateOutlet]="navigationItems" [ngTemplateOutletContext]="{isHighlighted: false}"></ng-container>
    </div>
    
    <div class="_divider"></div>

    <div class=" _container _user-container">
        <ion-icon src="./assets/icons/person-outline.svg"></ion-icon>  
        <div *ngIf="menuIsOpen">
            <p class="_username">
                <span>{{userDetails?.firstname}} {{userDetails?.lastname | shortenName}}</span>
            </p>
            <p class="_logout-button" (click)="this.authenticationService.logout()" [translate]="'NAVIGATION.LOGOUT'"></p>
        </div>
	</div>

    <div class="_divider"></div>

    <div class="_container _description-toggle-container">
        <div *ngIf="menuIsOpen" class="_description-toggle" (click)="toggleButtonDescription()">
            <ion-icon src="./assets/icons/double-left-outline.svg"></ion-icon>  
            <p [translate]="'NAVIGATION.MENU_IN'"></p>
        </div>
        <div *ngIf="!menuIsOpen" class="_description-toggle" (click)="toggleButtonDescription()">
            <ion-icon src="./assets/icons/double-right-outline.svg"></ion-icon>  
        </div>
    </div>

    <ng-container *ngIf="notInProduction">
        <div class="_divider"></div>

        <div class="_container _environment" [ngClass]="{'_small-menu': !menuIsOpen}">
            <p>{{'ENVIRONMENT' | translate}}: <b>{{environment}}</b></p>
        </div>
    </ng-container>
</div>


<ng-template #navigationItems let-isHighlighted="isHighlighted">
	<div class="_navigation-buttons">
		<div *ngFor="let route of routes | filter:isHighlighted:['highlight']" class="_navigation-button" (click)="navigateTo(route.route)" [ngClass]="{'_navigation-button-active': isActive(route.route), '_is-highlighted': route.highlight}">
			<div class="_navigation-icon-container">
				<ion-icon src="./assets/icons/{{route.icon}}.svg"></ion-icon>
			</div>
			<p *ngIf="menuIsOpen" class="_navigation-button-description" [translate]="'NAVIGATION.' + route.nameKey"></p>
			<div *ngIf="route.badge && route.badge | async as badgeResult" class="_badge"><span class="_count">{{badgeResult}}</span></div>
		</div>	
    </div>
</ng-template>